import { Text } from "@fluentui/react-components";
import { CaretDownFilled, CaretUpFilled } from "@fluentui/react-icons";
import React from "react";
import { useIntl } from "react-intl";

import { Flex } from "@tdp/common/fluentV9MigrationComponents";
import { EmptyState, useFilterFormattedString, getLocalisedFilterContent } from '@tdp/modules/apps'

import { TrendColor } from "./Charts.Styles";
import { ITrendDataPoint } from "./IAnalyticsCharts";


const getMinMaxValue = (data: ITrendDataPoint[], max: boolean): ITrendDataPoint => {
  return data.reduce((maxVal, currentPoint) => {
    if (max) {
      return currentPoint.value > maxVal.value ? currentPoint : maxVal;
    } else {
      return currentPoint.value < maxVal.value ? currentPoint : maxVal;
    }
  });
}

export const ChartTrendText: React.FC<{
  data?: ITrendDataPoint[],
  max: boolean,
  trendKey?: string
}> = ({ data, max, trendKey }) => {

  const intl = useIntl();
  const filterFormattedStrings = useFilterFormattedString(intl);

  if (!data || data.length == 0) return <EmptyState />

  const minMaxValue: ITrendDataPoint = getMinMaxValue(data, max);
  const trend: ITrendDataPoint = trendKey
    ? data.find((point) => point.key === trendKey) ?? minMaxValue
    : minMaxValue;

  const isTrendDown = trend.percent < 0 ? true : false
  const trendColor = isTrendDown ? TrendColor.Failure : TrendColor.Success

  return <Flex fill column vAlign="center" hAlign="center" gap="gap.small">
    <Flex gap="gap.small">
      <Text size={800} weight="semibold">{trend.stringValue}</Text>
      <Flex>
        {isTrendDown
          ? <CaretDownFilled fontSize={20} style={{ color: trendColor }} />
          : <CaretUpFilled fontSize={20} style={{ color: trendColor }} />
        }
        <Text style={{ color: trendColor }}>{Math.abs(trend.percent)}{"%"}</Text>
      </Flex>
    </Flex>
    <Text size={400}>
      {trendKey
        ? intl.formatMessage({ defaultMessage: "Active users", description: "Short name for the metric analyticsMetricNameMau30. For metric explanation see analyticsMetricTooltipTextMau30", })
        : getLocalisedFilterContent(intl, trend.key, filterFormattedStrings)
      }
    </Text>
  </Flex>
}





export default React.memo(ChartTrendText);